import { appCardShadows, type AppShadowTokens } from "./shadows";
import { theme, type ThemeConfig } from "antd";

import { appBrandPalettes, appGrayPalettes, appNeutralPalette } from "./palette";

const brand = appBrandPalettes.light;
const sidebar = appBrandPalettes.dark;
const neutral = Object.fromEntries(appNeutralPalette.map((color, index) => [`appNeutral${index + 1}`, color]));
const brandTokens = Object.fromEntries(brand.map((color, index) => [`appBrand${index + 1}`, color]));
const grayTokens = Object.fromEntries(appGrayPalettes.light.map((color, index) => [`appGray${index}`, color]));

// Подставляем brand до расчёта alias-токенов и стандартных токенов компонентов.
// Остальные цветовые семейства, в том числе green, рассчитывает AntD.
const lightBrandAlgorithm: typeof theme.defaultAlgorithm = (seed) => ({
  ...theme.defaultAlgorithm(seed),
  colorShadow: appBrandPalettes.light[9],
  colorPrimaryBg: brand[0],
  colorPrimaryBgHover: brand[1],
  colorPrimaryBorder: brand[2],
  colorPrimaryBorderHover: brand[3],
  colorPrimaryHover: brand[4],
  colorPrimary: brand[5],
  colorPrimaryActive: brand[6],
  // Светлые текстовые состояния AntD соответствуют оттенкам 5, 6 и 7.
  colorPrimaryTextHover: brand[4],
  colorPrimaryText: brand[5],
  colorPrimaryTextActive: brand[6],
  colorLinkHover: brand[6],
  colorLink: brand[5],
  colorLinkActive: brand[6],
});

const token: ThemeConfig["token"] & AppShadowTokens = {
  ...appCardShadows.light,
  ...neutral,
  ...brandTokens,
  ...grayTokens,
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  colorPrimary: brand[5],
  colorLink: brand[5],
  colorBgLayout: neutral.appNeutral2,
  colorBgContainer: neutral.appNeutral1,
  colorBgElevated: neutral.appNeutral1,
  colorBorder: neutral.appNeutral3,
  colorBorderSecondary: neutral.appNeutral3,
  colorSplit: neutral.appNeutral3,
};

export const lightTheme: ThemeConfig = {
  algorithm: lightBrandAlgorithm,
  token,
  components: {
    Card: {
      headerBg: neutral.appNeutral1,
    },
    Layout: {
      headerBg: neutral.appNeutral1,
      headerPadding: "0 24px",
      siderBg: sidebar[0],
      triggerBg: sidebar[0],
      triggerColor: neutral.appNeutral2,
    },
    // Sidebar остаётся тёмным и использует тёмную brand-палитру.
    Menu: {
      activeBarBorderWidth: 0,
      collapsedIconSize: 18,
      collapsedWidth: 64,
      darkGroupTitleColor: neutral.appNeutral5,
      darkItemBg: sidebar[0],
      darkItemColor: neutral.appNeutral2,
      darkItemDisabledColor: neutral.appNeutral5,
      darkItemHoverBg: sidebar[1],
      darkItemHoverColor: neutral.appNeutral1,
      darkItemSelectedBg: sidebar[3],
      darkItemSelectedColor: neutral.appNeutral1,
      darkPopupBg: sidebar[0],
      darkSubMenuItemBg: sidebar[0],
      iconMarginInlineEnd: 12,
      iconSize: 18,
      itemHeight: 44,
      itemMarginInline: 12,
      subMenuItemBorderRadius: 8,
    },
  },
};
